// extracted by mini-css-extract-plugin
module.exports = {"title":"typography_title__1_ejc"};